import { useLocation, useParams } from 'react-router';

export const useGetSprintId = () => {
  const params = useParams<{ sprintId: string }>();

  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const sprintIdFromQueryParam = searchParams.get('sprintId');
  const { pathname } = useLocation();

  function extractIdFromUrl(url) {
    const parts = url.split('/');
    const index = parts.indexOf('sprints');

    if (index !== -1) {
      const id = parts[index + 1];

      return id;
    }

    return null;
  }

  return {
    sprintId:
      params.sprintId ?? sprintIdFromQueryParam ?? extractIdFromUrl(pathname),
  };
};
